import cn from 'classnames'
import React, { ComponentProps } from 'react'

type XCircleIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function XCircleIcon(props: XCircleIconProps) {
  const { className = '', ...rest } = props

  return (
    <svg
      className={cn('XCircleIcon', className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <circle cx="12" cy="12" r="8" fill="#B3B7BE" />
      <path
        d="M9 9L15 15M15 9L9 15"
        stroke="white"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  )
}
